import { SkeletonOfAnySize } from 'src/components/Skeletons';
import { Copy } from 'src/components/svg/Copy';

interface CopyDataComponentProps {
  value: string;
  copyFunc: (value: string, textMessage: string) => void;
  text: string;
  title: string;
  textMessage: string;
  isLoading: boolean;
}

export const CopyDataComponent = ({
  title,
  value,
  copyFunc,
  text,
  textMessage,
  isLoading
}: CopyDataComponentProps) => {
  const handleCopy = (): void => {
    copyFunc(value, textMessage);
  };

  if (isLoading) {
    return (
      <SkeletonOfAnySize className="w-full h-[68px] min-h-[68px] mr-2 rounded object-contain flex" />
    );
  }

  return (
    <div className="flex flex-col gap-1 text-xs min-w-[180px] flex-1">
      <p className="text-i_icon font-medium">{title}</p>
      <p className="flex min-h-[48px] px-4 py-2 items-center justify-between bg-i_bg border border-border-input-default rounded-[20px]">
        <span className="text-i_text_disabled font-medium truncate block">{text}</span>
        <button className="ml-2" onClick={handleCopy} aria-label={text}>
          <Copy className="[&_path]:fill-i_text_disabled" />
        </button>
      </p>
    </div>
  );
};
